<template>
  <v-app>
    <v-app-bar
      app
      fixed
      color="primary"
      dark
      flat
      :dense="$vuetify.breakpoint.xsOnly"
      clipped-left
      style="z-index:10"
    >
      <v-toolbar-title class="hidden-sm-and-down mr-6">
        <router-link
          to="/"
          class="atlas-brand white--text"
        >
          atlas
        </router-link>
      </v-toolbar-title>

      <v-toolbar-title>
        {{ $route.meta.title || pageTitle || $route.name }}
      </v-toolbar-title>

      <v-spacer />
      <global-search />

      <v-toolbar-items
        v-if="!currentUser"
        class="hidden-sm-and-down"
      >
        <v-btn
          :href="{path: '/login', query: {redirect: $route.path}}"
          text
        >
          Login
        </v-btn>
      </v-toolbar-items>

      <secondary-nav
        v-if="secondaryNav"
        slot="extension"
      />
    </v-app-bar>

    <sidebar />

    <v-content id="main-content">
      <v-container
        fluid
        grid-list-lg
      >
        <router-view />
      </v-container>
    </v-content>

    <global-tools v-if="false" />

    <global-snackbar />

    <the-help-bar v-if="false" />

    <the-documents-menu />
  </v-app>
</template>

<script>
import config from '@/config'
import { mapState } from 'vuex'
import GlobalSearch from './GlobalSearch'
import GlobalSnackbar from './GlobalSnackbar'
import GlobalTools from './GlobalTools'
import SecondaryNav from './SecondaryNav'
import Sidebar from './Sidebar'
import TheDocumentsMenu from '@/components/documents/TheDocumentsMenu'
import TheHelpBar from '@/components/help/TheHelpBar'

export default {
  name: 'MainLayout',
  components: {
    GlobalSearch,
    GlobalSnackbar,
    GlobalTools,
    SecondaryNav,
    Sidebar,
    TheDocumentsMenu,
    TheHelpBar
  },
  data () {
    return {
      config
    }
  },
  computed: {
    ...mapState('navigation', [
      'secondaryNav',
      'pageTitle'
    ]),
    ...mapState('user', [ 'currentUser' ])
  }
}
</script>

<style>
#main-content {
  margin-bottom: 5em;
}

img {
  max-width: 100%;
  max-height: 100%;
}
</style>
